import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import react_google_recaptcha from "react-google-recaptcha";
import { createObj } from "./fable_modules/fable-library-js.4.17.0/Util.js";

export function recaptchaContainer(props) {
    return Interop_reactApi.createElement(react_google_recaptcha, createObj(props));
}

